export default {
  loading(state) {
    return state.loading;
  },
  filter(state) {
    return state.filter;
  },
  email(state) {
    return state.filter.email;
  },
  groups(state) {
    return state.filter.groups;
  },
  banks(state) {
    return state.banks;
  },
  filteredRecipients: (state) => (accounts) => {
    return state.recipients.filter((item) => accounts.includes(item.id));
  },
  urlShortnersOrder(state) {
    return state.urlShortners.sort((a, b) =>
      a.created_at > b.created_at ? 1 : -1,
    );
  },
  cooperatives(state) {
    return state.cooperatives;
  },
  utilityCompanyById: (state) => (id) => {
    return state.utilityCompanies.find(
      (utility_company) => utility_company.id == id,
    );
  },
  cooperativeById: (state) => (id) => {
    return state.cooperatives.find((cooperative) => cooperative.id == id);
  },
  partnerById: (state) => (id) => {
    return state.partners.find((partner) => partner.id == id);
  },
  powerPlantById: (state) => (id) => {
    return state.plants.find((powerPlant) => powerPlant.id == id);
  },
};
